import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const InspectioItems = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Inspection Items", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    editId: null,
    itemName: "",
  });

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const result = await apiClient.get("/inspections/inspection-items/");
        setData(result.data.response || result.data || []);
      } catch (err) {
        console.error("Error fetching inspection items:", err);
      }
    };
    fetchItems();
  }, [modalOpen]);

  const toggleModal = () => {
    setFormData({ editId: null, itemName: "" });
    setModalOpen(!modalOpen);
  };

  const handleSave = async () => {
    try {
      let response;
      if (formData.editId) {
        response = await apiClient.put(
          `/inspections/inspection-items/${formData.editId}`,
          {
            name: formData.itemName,
          }
        );
      } else {
        response = await apiClient.post("/inspections/inspection-items/", {
          name: formData.itemName,
        });
      }
      await showAlert({
        title: formData.editId
          ? "Update Inspection Item"
          : "Create Inspection Item",
        text: response.data.message,
        icon: response.data.status,
        goBack: false,
        timer: 5000,
      });
      if (response.data.status === "success") {
        setModalOpen(false);
        setFormData({ editId: null, itemName: "" });
      }
    } catch (err) {
      console.error("Error saving inspection item:", err);
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "name",
      header: "Inspection Item",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => (
        <span
          className={`badge bg-${
            row.original.status === "Active"
              ? "success"
              : row.original.status === "Inactive"
              ? "secondary"
              : "danger"
          }`}
        >
          {row.original.status}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              setFormData({
                editId: row.original.id,
                itemName: row.original.name,
              });
              setModalOpen(true);
            }}
          >
            <i className="ri-file-edit-line"></i>
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              title="Inspection Items"
              breadcrumbItems={breadcrumbItems}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-12 text-end mb-2">
                    <button className="btn btn-primary" onClick={toggleModal}>
                      Create Inspection Item
                    </button>
                  </div>
                </div>
                <TanstackTable data={data} columns={columns} />
              </CardBody>
            </Card>
          </div>
        </div>
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          centered={true}
          backdrop="static"
        >
          <ModalHeader toggle={toggleModal}>
            {formData.editId ? "Update" : "Create"} Inspection Item
          </ModalHeader>
          <ModalBody>
            <input
              type="text"
              className="form-control"
              placeholder="Inspection Item Name"
              value={formData.itemName}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, itemName: e.target.value }))
              }
              required
            />
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={!formData.itemName.trim()}
            >
              Save
            </button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default InspectioItems;
